// source: imports/ecom/payment_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb =
    require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var imports_ecom_currency_code_pb =
    require('../../imports/ecom/currency_code_pb.js');
goog.object.extend(proto, imports_ecom_currency_code_pb);
var imports_options_event_metadata_pb =
    require('../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
goog.exportSymbol(
    'proto.com.chegg.rio.backend.ecom.CommercePayment', null, global);
goog.exportSymbol('proto.com.chegg.rio.backend.ecom.PaymentInfo', null, global);
goog.exportSymbol(
    'proto.com.chegg.rio.backend.ecom.PaymentMethod', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.chegg.rio.backend.ecom.PaymentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.chegg.rio.backend.ecom.PaymentInfo.displayName =
      'proto.com.chegg.rio.backend.ecom.PaymentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.chegg.rio.backend.ecom.CommercePayment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.chegg.rio.backend.ecom.CommercePayment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.chegg.rio.backend.ecom.CommercePayment.displayName =
      'proto.com.chegg.rio.backend.ecom.CommercePayment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.toObject = function(
      opt_includeInstance) {
    return proto.com.chegg.rio.backend.ecom.PaymentInfo.toObject(
        opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.chegg.rio.backend.ecom.PaymentInfo} msg The msg instance
   *     to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.chegg.rio.backend.ecom.PaymentInfo.toObject = function(
      includeInstance, msg) {
    var f, obj = {
      paymentAuthorizedDatetime: (f = msg.getPaymentAuthorizedDatetime()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      paymentCreationDate: (f = msg.getPaymentCreationDate()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      currencyCode: jspb.Message.getFieldWithDefault(msg, 202, 0),
      paymentAmount:
          jspb.Message.getFloatingPointFieldWithDefault(msg, 203, 0.0),
      gatewayReferenceId: jspb.Message.getFieldWithDefault(msg, 204, ''),
      paymentMethod: jspb.Message.getFieldWithDefault(msg, 205, 0),
      orderUuid: jspb.Message.getFieldWithDefault(msg, 206, '')
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.deserializeBinary = function(
    bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.chegg.rio.backend.ecom.PaymentInfo;
  return proto.com.chegg.rio.backend.ecom.PaymentInfo
      .deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.chegg.rio.backend.ecom.PaymentInfo} msg The message object
 *     to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.deserializeBinaryFromReader =
    function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 200:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setPaymentAuthorizedDatetime(value);
        break;
      case 201:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setPaymentCreationDate(value);
        break;
      case 202:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
                reader.readEnum());
        msg.setCurrencyCode(value);
        break;
      case 203:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setPaymentAmount(value);
        break;
      case 204:
        var value = /** @type {string} */ (reader.readString());
        msg.setGatewayReferenceId(value);
        break;
      case 205:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.PaymentMethod} */ (
                reader.readEnum());
        msg.setPaymentMethod(value);
        break;
      case 206:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderUuid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.serializeBinary =
    function() {
  var writer = new jspb.BinaryWriter();
  proto.com.chegg.rio.backend.ecom.PaymentInfo.serializeBinaryToWriter(
      this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.chegg.rio.backend.ecom.PaymentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.serializeBinaryToWriter = function(
    message, writer) {
  var f = undefined;
  f = message.getPaymentAuthorizedDatetime();
  if (f != null) {
    writer.writeMessage(
        200, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = message.getPaymentCreationDate();
  if (f != null) {
    writer.writeMessage(
        201, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
      jspb.Message.getField(message, 202));
  if (f != null) {
    writer.writeEnum(202, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 203));
  if (f != null) {
    writer.writeFloat(203, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 204));
  if (f != null) {
    writer.writeString(204, f);
  }
  f = /** @type {!proto.com.chegg.rio.backend.ecom.PaymentMethod} */ (
      jspb.Message.getField(message, 205));
  if (f != null) {
    writer.writeEnum(205, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 206));
  if (f != null) {
    writer.writeString(206, f);
  }
};


/**
 * optional google.protobuf.Timestamp payment_authorized_datetime = 200;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype
    .getPaymentAuthorizedDatetime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 200));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype
    .setPaymentAuthorizedDatetime = function(value) {
  return jspb.Message.setWrapperField(this, 200, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype
    .clearPaymentAuthorizedDatetime = function() {
  return this.setPaymentAuthorizedDatetime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype
    .hasPaymentAuthorizedDatetime = function() {
  return jspb.Message.getField(this, 200) != null;
};


/**
 * optional google.protobuf.Timestamp payment_creation_date = 201;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.getPaymentCreationDate =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 201));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.setPaymentCreationDate =
    function(value) {
  return jspb.Message.setWrapperField(this, 201, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype
    .clearPaymentCreationDate = function() {
  return this.setPaymentCreationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.hasPaymentCreationDate =
    function() {
  return jspb.Message.getField(this, 201) != null;
};


/**
 * optional CurrencyCode currency_code = 202;
 * @return {!proto.com.chegg.rio.backend.ecom.CurrencyCode}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.getCurrencyCode =
    function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
      jspb.Message.getFieldWithDefault(this, 202, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.CurrencyCode} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.setCurrencyCode =
    function(value) {
  return jspb.Message.setField(this, 202, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.clearCurrencyCode =
    function() {
  return jspb.Message.setField(this, 202, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.hasCurrencyCode =
    function() {
  return jspb.Message.getField(this, 202) != null;
};


/**
 * optional float payment_amount = 203;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.getPaymentAmount =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 203, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.setPaymentAmount =
    function(value) {
  return jspb.Message.setField(this, 203, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.clearPaymentAmount =
    function() {
  return jspb.Message.setField(this, 203, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.hasPaymentAmount =
    function() {
  return jspb.Message.getField(this, 203) != null;
};


/**
 * optional string gateway_reference_id = 204;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.getGatewayReferenceId =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 204, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.setGatewayReferenceId =
    function(value) {
  return jspb.Message.setField(this, 204, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.clearGatewayReferenceId =
    function() {
  return jspb.Message.setField(this, 204, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.hasGatewayReferenceId =
    function() {
  return jspb.Message.getField(this, 204) != null;
};


/**
 * optional PaymentMethod payment_method = 205;
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentMethod}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.getPaymentMethod =
    function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.PaymentMethod} */ (
      jspb.Message.getFieldWithDefault(this, 205, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.PaymentMethod} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.setPaymentMethod =
    function(value) {
  return jspb.Message.setField(this, 205, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.clearPaymentMethod =
    function() {
  return jspb.Message.setField(this, 205, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.hasPaymentMethod =
    function() {
  return jspb.Message.getField(this, 205) != null;
};


/**
 * optional string order_uuid = 206;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.getOrderUuid =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 206, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.setOrderUuid = function(
    value) {
  return jspb.Message.setField(this, 206, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentInfo} returns this
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.clearOrderUuid =
    function() {
  return jspb.Message.setField(this, 206, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.PaymentInfo.prototype.hasOrderUuid =
    function() {
  return jspb.Message.getField(this, 206) != null;
};



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.toObject =
      function(opt_includeInstance) {
    return proto.com.chegg.rio.backend.ecom.CommercePayment.toObject(
        opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.chegg.rio.backend.ecom.CommercePayment} msg The msg
   *     instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.chegg.rio.backend.ecom.CommercePayment.toObject = function(
      includeInstance, msg) {
    var f, obj = {
      authorizedDatetime: (f = msg.getAuthorizedDatetime()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      creationDate: (f = msg.getCreationDate()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      currencyCode: jspb.Message.getFieldWithDefault(msg, 202, 0),
      amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 203, 0.0),
      gatewayReferenceId: jspb.Message.getFieldWithDefault(msg, 204, ''),
      paymentMethod: jspb.Message.getFieldWithDefault(msg, 205, 0),
      orderUuid: jspb.Message.getFieldWithDefault(msg, 210, '')
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.deserializeBinary = function(
    bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.chegg.rio.backend.ecom.CommercePayment;
  return proto.com.chegg.rio.backend.ecom.CommercePayment
      .deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.chegg.rio.backend.ecom.CommercePayment} msg The message
 *     object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.deserializeBinaryFromReader =
    function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 200:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setAuthorizedDatetime(value);
        break;
      case 201:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreationDate(value);
        break;
      case 202:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
                reader.readEnum());
        msg.setCurrencyCode(value);
        break;
      case 203:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setAmount(value);
        break;
      case 204:
        var value = /** @type {string} */ (reader.readString());
        msg.setGatewayReferenceId(value);
        break;
      case 205:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.PaymentMethod} */ (
                reader.readEnum());
        msg.setPaymentMethod(value);
        break;
      case 210:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderUuid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.serializeBinary =
    function() {
  var writer = new jspb.BinaryWriter();
  proto.com.chegg.rio.backend.ecom.CommercePayment.serializeBinaryToWriter(
      this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.chegg.rio.backend.ecom.CommercePayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.serializeBinaryToWriter =
    function(message, writer) {
  var f = undefined;
  f = message.getAuthorizedDatetime();
  if (f != null) {
    writer.writeMessage(
        200, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = message.getCreationDate();
  if (f != null) {
    writer.writeMessage(
        201, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
      jspb.Message.getField(message, 202));
  if (f != null) {
    writer.writeEnum(202, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 203));
  if (f != null) {
    writer.writeFloat(203, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 204));
  if (f != null) {
    writer.writeString(204, f);
  }
  f = /** @type {!proto.com.chegg.rio.backend.ecom.PaymentMethod} */ (
      jspb.Message.getField(message, 205));
  if (f != null) {
    writer.writeEnum(205, f);
  }
  f = message.getOrderUuid();
  if (f.length > 0) {
    writer.writeString(210, f);
  }
};


/**
 * optional google.protobuf.Timestamp authorized_datetime = 200;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .getAuthorizedDatetime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 200));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .setAuthorizedDatetime = function(value) {
  return jspb.Message.setWrapperField(this, 200, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .clearAuthorizedDatetime = function() {
  return this.setAuthorizedDatetime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .hasAuthorizedDatetime = function() {
  return jspb.Message.getField(this, 200) != null;
};


/**
 * optional google.protobuf.Timestamp creation_date = 201;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.getCreationDate =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 201));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.setCreationDate =
    function(value) {
  return jspb.Message.setWrapperField(this, 201, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.clearCreationDate =
    function() {
  return this.setCreationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.hasCreationDate =
    function() {
  return jspb.Message.getField(this, 201) != null;
};


/**
 * optional CurrencyCode currency_code = 202;
 * @return {!proto.com.chegg.rio.backend.ecom.CurrencyCode}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.getCurrencyCode =
    function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.CurrencyCode} */ (
      jspb.Message.getFieldWithDefault(this, 202, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.CurrencyCode} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.setCurrencyCode =
    function(value) {
  return jspb.Message.setField(this, 202, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.clearCurrencyCode =
    function() {
  return jspb.Message.setField(this, 202, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.hasCurrencyCode =
    function() {
  return jspb.Message.getField(this, 202) != null;
};


/**
 * optional float amount = 203;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.getAmount =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 203, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.setAmount = function(
    value) {
  return jspb.Message.setField(this, 203, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.clearAmount =
    function() {
  return jspb.Message.setField(this, 203, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.hasAmount =
    function() {
  return jspb.Message.getField(this, 203) != null;
};


/**
 * optional string gateway_reference_id = 204;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .getGatewayReferenceId = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 204, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .setGatewayReferenceId = function(value) {
  return jspb.Message.setField(this, 204, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .clearGatewayReferenceId = function() {
  return jspb.Message.setField(this, 204, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype
    .hasGatewayReferenceId = function() {
  return jspb.Message.getField(this, 204) != null;
};


/**
 * optional PaymentMethod payment_method = 205;
 * @return {!proto.com.chegg.rio.backend.ecom.PaymentMethod}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.getPaymentMethod =
    function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.PaymentMethod} */ (
      jspb.Message.getFieldWithDefault(this, 205, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.PaymentMethod} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.setPaymentMethod =
    function(value) {
  return jspb.Message.setField(this, 205, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.clearPaymentMethod =
    function() {
  return jspb.Message.setField(this, 205, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.hasPaymentMethod =
    function() {
  return jspb.Message.getField(this, 205) != null;
};


/**
 * optional string order_uuid = 210;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.getOrderUuid =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 210, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.CommercePayment} returns this
 */
proto.com.chegg.rio.backend.ecom.CommercePayment.prototype.setOrderUuid =
    function(value) {
  return jspb.Message.setProto3StringField(this, 210, value);
};


/**
 * @enum {number}
 */
proto.com.chegg.rio.backend.ecom.PaymentMethod = {
  UNKNOWN_PAYMENTMETHOD: 0,
  CHECK: 1,
  CHEGG_CREDIT: 2,
  CREDIT_CARD: 3,
  GIFT_CARD: 4,
  GOOGLEIAP: 5,
  MASTERPASS: 6,
  PAYPAL: 7,
  PAYPALMASSPAY: 8,
  APPLEPAY: 9,
  UPI: 10,
  VENMO: 11,
  GPAY: 12,
  APPLEIAP: 13
};

goog.object.extend(exports, proto.com.chegg.rio.backend.ecom);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/ecom/payment_info_pb.js
// module id = 1453
// module chunks = 11